// const axios = require('axios')
// import React from "react"
// import defaultConfig from '../config/defaultConfig'
// // import encrypted from '../helper'

// class Http extends React.Component  {
//     constructor(props) {
//         super(props)
//         this.http = this.http.bind(this)
//     }
    
//     http(method, endpoint, params, data = {}, headerData = '') {
//         const headers = {}
//         headers['Access-Control-Allow-Headers'] = '*'
//         headers['Authorization'] = this.getToken()
//         const getUserData = JSON.parse(localStorage.getItem('userData'))
//         if (getUserData && getUserData.eid) {
//             headers['usedwhich'] = getUserData.eid.split('-')[0]
//         }
//         if (headerData) {
//             for (const key in headerData) {
//                 headers[key] = headerData[key]
//             }
//         }
//         return axios({
//             method,
//             url: `${defaultConfig.GAVL_BACKEND_URL}/${endpoint}`,
//             headers,
//             params,
//             data
//           })
//             .then(response => response.data)
//     }
//     getToken() {
//         return localStorage.getItem('accessToken')
//       }
// }
// export default Http


const axios = require("axios")
import React from "react"
import defaultConfig from "../config/defaultConfig"
import { getMachineId } from "../../utility/machineID"

class Http extends React.Component {
  constructor(props) {
    super(props)

    this.http = this.http.bind(this)
    this.logoutUser = this.logoutUser.bind(this)
  }

  logoutUser() {
    if (window.location.pathname.includes("/login")) {
      return
    }

    localStorage.removeItem("accessToken")
    localStorage.removeItem("sessionContext")
    localStorage.removeItem("userData")
    localStorage.removeItem("usedwhich")
    localStorage.removeItem("dbname")
    localStorage.removeItem("tokenExpiry")

    window.location.replace("/login")
  }

  http(method, endpoint, params = {}, data = {}, headerData = {}) {
    const headers = {
      Accept: "application/json"
    }

    const token = localStorage.getItem("accessToken")
    const sessionContext = localStorage.getItem("sessionContext")
    const usedwhich = localStorage.getItem("usedwhich")

    if (token) {
      headers.Authorization = `Bearer ${token}`
    }

    if (sessionContext) {
      headers["X-Session-Context"] = sessionContext
    }

    if (usedwhich) {
      headers.usedwhich = usedwhich
    }

    if (!sessionContext) {
      headers["X-Machine-Id"] = getMachineId()
    }

    if (headerData) {
      Object.assign(headers, headerData)
    }

    return axios({
      method,
      url: `${defaultConfig.GAVL_BACKEND_URL}/${endpoint}`,
      headers,
      params,
      data
    })
      .then((response) => response.data)
      .catch((error) => {
        const status = error.response?.status
        const apiCode = error.response?.data?.code

        if (status === 401 || apiCode === 401) {
          this.logoutUser()
        }

        return Promise.reject(error)
      })
  }
}

export default Http